import React from 'react';

// ─── Splash ───────────────────────────────────────────────────────────────────
export function SplashStep() {
  return (
    <div style={{ display:'flex', flexDirection:'column', alignItems:'center', gap:28, textAlign:'center' }}>
      <div className="splash-logo">
        <div className="splash-ring splash-ring1"/><div className="splash-ring splash-ring2"/><div className="splash-ring splash-ring3"/>
        <div style={{ width:88,height:88,borderRadius:24,zIndex:1,position:'relative', background:'linear-gradient(135deg,#7c3aed,#4f46e5)', display:'flex',alignItems:'center',justifyContent:'center', boxShadow:'0 0 40px rgba(124,58,237,0.6)',fontSize:40 }}>🎓</div>
      </div>
      <div className="splash-text">
        <div style={{ fontSize:36,fontWeight:900,color:'#fff',letterSpacing:'-0.03em',lineHeight:1.1 }}>Aluno Conectado</div>
        <div style={{ fontSize:14,fontWeight:600,color:'#7c3aed',marginTop:8,letterSpacing:'0.2em',textTransform:'uppercase' }}>Simulation Studio</div>
      </div>
      <div className="splash-loader"><div className="splash-loader-bar"/></div>
    </div>
  );
}
